import DisplayComments from "./DisplayComments";
import TableCellAdjustment from "./TableCellAdjustment";
import TableCellSafetyMargin from "./TableCellSafetyMargin";
import TableCellWeek1 from "./TableCellWeek1";
import TableCellWeek2 from "./TableCellWeek2";
import TableCellWeek3 from "./TableCellWeek3";
import TableCellWeek4 from "./TableCellWeek4";
import TableCellWeek5 from "./TableCellWeek5";
import { formatNumber } from "./defineUtils";
import CustomerTrustPopover from "./CustomerTrustPopover";
import CustomerTypePopover from "./CustomerTypePopover";

export const weeklyDepCols = [
   {
      field: "name",
      headerName: "Customer / CG ",
      hideSortIcons: "false",
      width: 300,
   },
   {
      field: "customerNumber",
      headerName: "Customer Number",
      hideSortIcons: "false",
      width: 120,
   },
   {
      field: "type",
      headerName: "Customer Type",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 170,
      sortable: false,
      renderHeader: (params) => {
         return <CustomerTypePopover />;
      },
   },
   {
      field: "skuName",
      headerName: "SKU / PG ",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
   },
   {
      field: "skuNumb",
      headerName: "SKU Number",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
   },
   {
      field: "customerTrustLevel",
      headerName: "Relationship Level",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 120,
      sortable: false,
      renderHeader: (params) => {
         return <CustomerTrustPopover />;
      },
   },
   {
      field: "skuPercentage",
      headerName: "SKU Market Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      hideSortIcons: "false",
      // valueGetter: (params) => {
      //    return `${params.row.skuPercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "customerSharePercentage",
      headerName: "Cust Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      hideSortIcons: "false",
      // valueGetter: (params) => {
      //    return `${params.row.customerSharePercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "initialQuota",
      headerName: "Initial Quota",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      hideSortIcons: "false",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
   {
      field: "safetyMargin",
      headerName: "Safety margin %",
      width: 100,
      renderCell: TableCellSafetyMargin,
   },
   {
      field: "unusedQuota",
      headerName: "Unused Quota - Previous Period",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      hideSortIcons: "false",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
   {
      field: "adjustment",
      headerName: "Adjustment",
      width: 100,
      renderCell: TableCellAdjustment,
   },
   {
      field: "quota",
      headerName: "Quota",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
   {
      field: "weekly1",
      headerName: "Week1",
      width: 100,
      renderCell: TableCellWeek1,
   },
   {
      field: "weekly2",
      headerName: "Week2",
      width: 100,
      renderCell: TableCellWeek2,
   },
   {
      field: "weekly3",
      headerName: "Week3",
      width: 100,
      renderCell: TableCellWeek3,
   },
   {
      field: "weekly4",
      headerName: "Week4",
      width: 100,
      renderCell: TableCellWeek4,
   },
   {
      field: "weekly5",
      headerName: "Week5",
      width: 100,
      renderCell: TableCellWeek5,
   },
   {
      field: "customerQuotaComments",
      headerName: "Comments",
      renderCell: DisplayComments
   },
];

export const biWeeklyDepCols = [
   {
      field: "name",
      headerName: "Customer / CG ",
      hideSortIcons: "false",
      width: 220,
   },
   {
      field: "customerNumber",
      headerName: "Customer Number",
      hideSortIcons: "false",
      width: 120,
   },
   {
      field: "type",
      headerName: "Customer Type",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 165,
      sortable: false,
      renderHeader: (params) => {
         return <CustomerTypePopover />;
      },
   },
   {
      field: "skuName",
      headerName: "SKU / PG ",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
   },
   {
      field: "skuNumb",
      headerName: "SKU Number",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
   },
   {
      field: "customerTrustLevel",
      headerName: "Relationship Level",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 120,
      sortable: false,
      renderHeader: (params) => {
         return <CustomerTrustPopover />;
      },
   },
   {
      field: "skuPercentage",
      headerName: "SKU Market Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      hideSortIcons: "false",
      // valueGetter: (params) => {
      //    return `${params.row.skuPercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "customerSharePercentage",
      headerName: "Cust Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      hideSortIcons: "false",
      // valueGetter: (params) => {
      //    return `${params.row.customerSharePercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "initialQuota",
      headerName: "Initial Quota",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      hideSortIcons: "false",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
   {
      field: "safetyMargin",
      headerName: "Safety margin %",
      width: 100,
      renderCell: TableCellSafetyMargin,
   },
   {
      field: "unusedQuota",
      headerName: "Unused Quota - Previous Period",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      hideSortIcons: "false",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
   {
      field: "adjustment",
      headerName: "Adjustment",
      width: 100,
      renderCell: TableCellAdjustment,

   },
   {
      field: "quota",
      headerName: "Quota",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },

   },
   {
      field: "weekly1",
      headerName: "First Half",
      width: 100,
      renderCell: TableCellWeek1,
   },
   {
      field: "weekly2",
      headerName: "Second Half",
      width: 100,
      renderCell: TableCellWeek2,
   },
   {
      field: "customerQuotaComments",
      headerName: "Comments",
      renderCell: DisplayComments
   },
];

export const noDepCols = [
   {
      field: "name",
      headerName: "Customer / CG ",
      hideSortIcons: "false",
      width: 250,
   },
   {
      field: "customerNumber",
      headerName: "Customer Number",
      hideSortIcons: "false",
      width: 110,
   },
   {
      field: "type",
      headerName: "Customer Type",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      align: "center",
      width: 180,
      sortable: false,
      renderHeader: (params) => {
         return <CustomerTypePopover />;
      },
   },
   {
      field: "skuName",
      headerName: "SKU / PG ",
      disableColumnMenu: false,
      filterable: true,
      width: 200,
      hideSortIcons: "false",
   },
   {
      field: "skuNumb",
      headerName: "SKU Number",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
   },
   {
      field: "customerTrustLevel",
      headerName: "Relationship Level",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      align: "center",
      width: 120,
      sortable: false,
      renderHeader: (params) => {
         return <CustomerTrustPopover />;
      },
   },
   {
      field: "skuPercentage",
      headerName: "SKU Market Share %",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      align: "center",
      width: 120,
      // valueGetter: (params) => {
      //    return `${params.row.skuPercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "customerSharePercentage",
      headerName: "Cust Share %",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      align: "center",
      width: 70,
      // valueGetter: (params) => {
      //    return `${params.row.customerSharePercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "initialQuota",
      headerName: "Initial Quota",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      width: 70,
      align: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
   {
      field: "safetyMargin",
      headerName: "Safety margin %",
      width: 100,
      align: "center",
      renderCell: TableCellSafetyMargin,
   },
   {
      field: "unusedQuota",
      headerName: "Unused Quota - Previous Period",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      width: 70,
      align: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
   {
      field: "adjustment",
      headerName: "Adjustment",
      width: 100,
      align: "center",
      renderCell: TableCellAdjustment,
   },
   {
      field: "quota",
      headerName: "Quota",
      width: 70,
      align: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
   {
      field: "customerQuotaComments",
      headerName: "Comments",
      align: "center",
      renderCell: DisplayComments
   },
];

export const summaryView = [
   {
      field: "name",
      headerName: "Customer / CG ",
      flex: 2,
   },
   {
      field: "customerNumber",
      headerName: "Customer Number",
      flex: 1,
   },
   {
      field: "skuName",
      headerName: "SKU / PG ",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      flex: 2,
   },
   {
      field: "skuNumb",
      headerName: "SKU Number",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      flex: 1,
   },
   {
      field: "quota",
      headerName: "Quota",
      flex: 1,
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
      },
   },
];